import Hero from './components/Hero'
import Problem from './components/Problem'
import Solution from './components/Solution'
import Credibility from './components/Credibility'
import Urgency from './components/Urgency'
import Benefits from './components/Benefits'
import SignUp from './components/SignUp'
import FAQ from './components/FAQ'
import FinalCTA from './components/FinalCTA'
import Footer from './components/Footer'

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Problem />
      <Solution />
      <Credibility />
      <Urgency />
      <Benefits />
      <SignUp />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  )
}

export default App
